import { NavBar } from 'components/shared/NavBar';
import Script from 'next/script';

const Page = () => {
	return (
		<Script
			id="CookieDeclaration"
			src="https://consent.cookiebot.com/7b5ac1f7-7e11-40ad-8150-a23fd5af8b27/cd.js"
			type="text/javascript"
		/>
	);
};

export default Page;
